import React from 'react'
import Tabs from 'antd/lib/tabs'
import Progress from 'antd/lib/progress'
import { ClassesPropsType } from 'Components/tasks/Classes/Classes'
import { useEffect, useState } from 'react'
import { ClassItem } from 'Types/Classes.types'
import classes from './Classes.module.less'
import { ClassesListTab } from './ClassesListTab'

export const ClassesBody = (props: ClassesPropsType) => {
    const [filteredClasses, setFilteredClasses] = useState<ClassItem[]>(props.classes)
    const [searchText, setSearchText] = useState('')
    const classLevelElement = props.getClassLevelAttributeElement?.()
    const hasClassLevelAttributes = !!classLevelElement
    const activeTab = props.getActiveClassesTab?.() ?? 'overall'
    const progress = props.getClassAttributesProgress?.()

    useEffect(() => {
        if (searchText === '') {
            setFilteredClasses(props.classes)
            return
        }
        setFilteredClasses(
            props.classes.filter(classItem =>
                classItem.label.toLowerCase().includes(searchText.toLowerCase())
            )
        )
    }, [props.classes, searchText])

    if (!hasClassLevelAttributes) {
        return (
            <div className={classes['classes-body']}>
                <ClassesListTab
                    {...props}
                    getFilteredClasses={() => filteredClasses}
                    getSearchText={() => searchText}
                    setSearchText={setSearchText}
                />
            </div>
        )
    }

    return (
        <div className={classes['classes-body']}>
            <div className={classes['class-attributes-progress']}>
                <div className={classes['class-attributes-progress-text']}>
                    {(progress?.remaining ?? 0).toString()} fields left
                </div>
                <Progress
                    percent={progress?.percent ?? 0}
                    showInfo={false}
                    className={classes['class-attributes-progress-bar']}
                />
            </div>
            <Tabs
                className={classes['classes-tabs']}
                activeKey={activeTab}
                onChange={props.setActiveClassesTab}
                items={[
                    {
                        key: 'class-attributes',
                        label: 'Class level',
                        forceRender: true,
                        children: (
                            <div>
                                {classLevelElement &&
                                    React.cloneElement(classLevelElement, {
                                        key: `class-level-${
                                            (props.getAnnotationList?.() ?? []).length
                                        }`,
                                    })}
                            </div>
                        ),
                    },
                    {
                        key: 'overall',
                        label: 'Overall',
                        children: (
                            <ClassesListTab
                                {...props}
                                getFilteredClasses={() => filteredClasses}
                                getSearchText={() => searchText}
                                setSearchText={setSearchText}
                            />
                        ),
                    },
                ]}
            />
        </div>
    )
}
